// @flow
import {
  SHOP_DELIVERY_POINTS_REQUEST,
  SHOP_DELIVERY_POINTS_SUCCESS,
  SHOP_DELIVERY_POINTS_FAILURE,
  SHOP_DELIVERY_POINTS_CLEAR,
  SHOP_DELIVERY_POINTS_CURRENT,
} from 'app/common/actions/shop/order/deliveryPoints';


type DefaultState = {
  data: Array<{
    id: number,
    name: string,
    phone: ?string,
    postal_code: ?string,
    state_name: ?string,
    city: ?string,
    street: ?string,
    latitude: null, // ?
    longitude: null, // ?
    is_cash_available: ?boolean,
    is_card_available: ?boolean,
    weekday_from: ?number,
    weekday_to: ?number,
    weekend_from: null, // ?
    weekend_to: null, // ?
    description: ?string,
    uuid: string,
    stock_location: {
      id: number,
      name: string,
    }
  }>,
  loading: boolean,
  currentDeliveryPointId: ?number,
}

const defaultState: DefaultState = {
  data: [],
  loading: true,
  currentDeliveryPointId: null,
};

// $FlowFixMe
const deliveryPoints = (state = defaultState, { type, payload }) => {
  switch (type) {
    case SHOP_DELIVERY_POINTS_REQUEST: {
      return { ...state, loading: true };
    }

    case SHOP_DELIVERY_POINTS_SUCCESS: {
      return { ...state, ...payload, loading: false };
    }

    case SHOP_DELIVERY_POINTS_FAILURE: {
      return defaultState;
    }

    case SHOP_DELIVERY_POINTS_CLEAR: {
      return defaultState;
    }

    case SHOP_DELIVERY_POINTS_CURRENT: {
      return { ...state, currentDeliveryPointId: payload };
    }

    default:
  }
  return state;
};

export default deliveryPoints;
